const Link = {
   baseStyle: {
      color: 'brand.500',
      fontWeight: 'semibold',
      _hover: {
         textDecoration: 'none',
      },
      _visited: {
         color: 'brand.500',
      },
   },
   sizes: {
      sm: {
         fontSize: 'md',
      },
      md: {
         fontSize: 'lg',
      },
      lg: {
         fontSize: 'xl',
      },
   },
   variants: {
      underline: {
         textDecoration: 'underline',
         _hover: {
            textDecoration: 'underline',
         },
      },
   },
};

export default Link;
